<template>
  <div>
    <div class="d-flex justify-center align-center flex-column d-print-none">
      <v-alert
        v-if="isBadQrCodeRequest"
        class="mt-10"
        width="30rem"
        color="red"
        dismissible
        type="error"
        >Резултът не може да бъде намерен. Опитайте да въведете телефонен номер
        и контролен номер във формата по-долу.
      </v-alert>
      <v-alert
        v-if="isBadRequest"
        class="mt-10"
        width="30rem"
        color="red"
        dismissible
        type="error"
        >Резултът не може да бъде намерен. Проверете въведените дани.
      </v-alert>
      <v-card v-if="!result" width="20rem" class="pa-4 mt-10">
        <v-form
          class="d-flex justify-center flex-column"
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-text-field
            v-model="phoneNumber"
            label="Телефон"
            required
          ></v-text-field>

          <v-text-field
            v-model="testNumber"
            label="Контролен номер"
            required
          ></v-text-field>

          <v-btn :disabled="!valid" color="success" @click="getResult">
            Провери
          </v-btn>
        </v-form>
      </v-card>
      <v-card v-else class="mt-10 pa-10 d-flex flex-column">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-for="(item, index) in displayableResult" :key="index">
                <td>{{ item.field }}</td>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-btn
          class="mt-10 align-self-end"
          color="success"
          @click="printResult"
        >
          <v-icon class="mr-2">mdi-printer</v-icon>
          Принтирай
        </v-btn>
      </v-card>
    </div>
    <div v-if="result" class="d-print-block printable">
      <img class="logo" src="./../assets/mbal_logo.png" />
      <span class="title"
        >„МНОГОПРОФИЛНА БОЛНИЦА ЗА АКТИВНО ЛЕЧЕНИЕ – БЛАГОЕВГРАД„ АД</span
      >
      <span class="title-2"
        >гр. Благоевград, ул. „Славянска” № 60, тел. 073/82-92-329, факс: 073/
        88-41-29</span
      >
      <span class="fish">
        <h2>ФИШ ЗА ВИРУСОЛОГИЧНО (PCR) ИЗСЛЕДВАНЕ</h2>
      </span>
      <span class="patient patient-name">
        <span>
          <b
            >{{ result.firstName }} {{ result.middleName }}
            {{ result.lastName }}</b
          >
        </span>
      </span>
      <span class="patient patient-info">
        <span>
          ЕГН:
          <b>{{ result.personalId }}</b>
        </span>
        <span>
          Възраст:
          <b>{{ result.age }}</b>
        </span>
        <span>
          Пол:
          <b>{{ result.sex | printableSex }}</b>
        </span>
        <span>
          Телефон:
          <b>{{ result.phoneNumber }}</b>
        </span>
      </span>
      <span class="patient">
        <span
          >Личен лекар:
          _________________________________________________________________________________________</span
        >
      </span>
      <span class="patient">
        <span>Амб./ИЗ № _____________ Дата ____/____/202___</span>
      </span>
      <span class="patient">
        <span>
          Материал за изследване:
          <b>назо-фарингеален секрет</b>
        </span>
      </span>
      <span class="patient">
        <span>
          Да бъде извършено изследване за:
          <b>SARS-CoV-2 RNA (COVID-19)</b>
        </span>
      </span>
      <span class="patient">Резултати и дата на предишно изследване:</span>
      <span class="patient"
        >Дата ____/____/202___ Резултат:
        _______________________________________________________________________</span
      >
      <span class="patient"
        >Дата ____/____/202___ Резултат:
        _______________________________________________________________________</span
      >
      <span class="patient doctor send">
        <span>Изпращащ лекар:__________________________________</span>
        <span>Гр.__________________________________</span>
      </span>
      <hr class="patient" />
      <span class="patient">
        <span>
          Дата на постъпване на материала в лабораторията:
          <b>{{ result.testDate | moment }}</b>
        </span>
      </span>
      <span class="patient">
        <span>Годност на материала: ☐ Годен ☐ Негоден</span>
      </span>
      <span class="patient">
        <span>
          Лабораторен номер:
          <b>{{ result.indexNumber }}</b>
        </span>
      </span>
      <span class="patient">
        <span>
          <b>РЕЗУЛТАТ НА ПРОВЕДЕНОТО ИЗСЛЕДВАНЕ</b>
        </span>
      </span>
      <span class="patient result">
        <span>
          <b>SARS-CoV-2 RNA (COVID-19):</b>
          <b>{{ result.testResult | printableResult }}</b>
        </span>
      </span>
      <span class="patient">
        <span>
          Дата на излизане на резултата:
          <b>{{ result.resultDate | moment }}</b>
        </span>
      </span>
      <span class="patient doctor">
        <span>Извършил изследването:</span>
      </span>
      <span class="patient doctor signature">Подпис и личен печат</span>
    </div>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import * as queries from "../graphql/queries";
import moment from "moment";
export default {
  name: "Results",
  props: {
    id: String,
  },
  data() {
    return {
      displayableResult: [],
      isGotResult: false,
      phoneNumber: null,
      testNumber: null,
      valid: false,
      result: null,
    };
  },
  computed: {
    isBadRequest() {
      return !this.result && !this.isQrCodeRequest && this.isGotResult;
    },
    isBadQrCodeRequest() {
      return !this.result && this.isQrCodeRequest;
    },
    isQrCodeRequest() {
      return !!this.id;
    },
  },
  methods: {
    displayResult() {
      this.displayableResult = (({
        firstName,
        middleName,
        lastName,
        personalId,
        resultDate,
        testResult,
        checkedOut,
      }) => [
        { field: "Име", value: `${firstName} ${middleName} ${lastName}` },
        { field: "ЕГН/ЛНЧ", value: personalId },
        {
          field: "Дата на резултата",
          value: this.$options.filters.moment(resultDate),
        },
        {
          field: "Резултат",
          value: checkedOut ? this.$options.filters.printableResult(testResult) : "Обработва се", 
        },
      ])(this.result);
    },
    printResult() {
      window.print();
    },
    async getResult() {
      this.result = (
        await this.fetchResultByNumbers()
      ).data.syncNewPcrTests.items[0];

      this.isGotResult = true;
      if (this.result) {
        this.displayResult();
      }
    },
    async fetchResultByNumbers() {
      const filter = {
        indexNumber: {
          eq: this.testNumber,
        },
        phoneNumber: {
          eq: this.phoneNumber,
        },
      };
      return await API.graphql({
        query: queries.syncNewPcrTests,
        variables: { filter },
      });
    },
    async fetchResultById() {
      const filter = {
        id: {
          eq: this.id,
        },
      };
      return await API.graphql({
        query: queries.syncNewPcrTests,
        variables: { filter },
      });
    },
  },
  async created() {
    if (this.$route.params.id) {
      this.result = (
        await this.fetchResultById()
      ).data.syncNewPcrTests.items[0];
    }

    if (this.result) {
      this.displayResult();
    }
  },
  filters: {
    moment: function (date) {
      return date ? moment(Number(date)).format("DD/MM/YYYY") : "";
    },
    printableSex: function (sex) {
      return sex === "Male" ? "Мъж" : "Жена";
    },
    printableResult: (result) => {
      const possibleResults = {
        Positive: "Положителен",
        Negative: "Отрицателен",
        Doubtful: "Съмнителен",
        InProgres: "Обработва се"
      };
      return possibleResults[result];
    },
  },
};
</script>

<style scoped>
.printable {
  padding: 2rem;
  display: none;
}

.patient {
  font-size: 16px;
  width: 100%;
  display: flex;
  margin-top: 1rem;
}

.patient-info {
  justify-content: space-between;
}
.patient-name {
  font-size: 20px;
  justify-content: space-evenly;
}
.result {
  border: 2px solid;
  padding: 1rem;
  justify-content: center;
}

.doctor {
  justify-content: center;
}
.signature {
  text-align: end;
  display: flex;
  flex-direction: column;
  font-size: 10px;
}

.send {
  text-align: end;
  display: flex;
  flex-direction: column;
}

.title,
.title-2 {
  float: left;
  width: 40rem;
  text-align: center;
}

.logo {
  width: 80px;
  float: left;
}

.fish {
  margin: 40px auto;
  float: left;
  text-decoration: underline;
}
@media print {
  @page {
    size: auto;
    margin: 0;
  }
}
</style>